import React, { useEffect, useState } from "react";
import UnlimitBreadcrumb from "../../../components/ui-kit/unlimit-breadcrumb";
import { useTranslation } from "react-i18next";
import useRoleAndPerm from "../../../utils/permissionFunction";
import Select from "react-select";
import { useSelector } from "react-redux";
import OutletCCTVList from "../outlets/Details/outlet-cctv-list";
import { Link } from "react-router-dom";
import { Plus } from "react-feather";
const CCTVList = () => {
  const { t } = useTranslation();
  const companies = useSelector((state) => state.companies.companies);

  const breadcrumbItems = [
    { label: "", link: "/", icon: "feather-home" },
    { label: t("tableColumnName.cctv"), active: true },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex flex-column">
              <div className="page-title">
                <h4>{t("tableColumnName.cctv")}</h4>
              </div>
              <UnlimitBreadcrumb items={breadcrumbItems} />
            </div>
          {/*   <div className="page-btn">
              <Link  className="btn btn-added">
                <Plus className="me-2 iconsize" />
                {t("general.button.addNew")}
              </Link>
            </div> */}
          </div>
          <div className="card table-list-card">
            <div className="card-body pt-3">
              <OutletCCTVList type="OUTLET" isEditTrue={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CCTVList;
